module.exports = __webpack_public_path__ + "static/img/lb.ca00b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lb.png
// module id = 192
// module chunks = 4